<!--64  DeleteDuplicateMimes-->
<div class="dx-field">
  <div class="dx-field-label">{{ 'NUR MIME_SOURCE verwenden' | translate }}</div>
  <div class="dx-field-value">
    <div class="d-flex flex-row">
      <dx-switch [(value)]="useOnlyMimeSource"></dx-switch>
    </div>
  </div>
</div>
